import {
  ArrowRightLeftIcon,
  BanIcon,
  BotIcon,
  ClipboardListIcon,
  FileWarningIcon,
  FolderSyncIcon,
  Gamepad2Icon,
  GitBranchIcon,
  HandHeartIcon,
  HeartIcon,
  LanguagesIcon,
  LayersIcon,
  LibraryIcon,
  ListChecksIcon,
  MedalIcon,
  MonitorPlayIcon,
  PackageOpenIcon,
  PaletteIcon,
  PieChartIcon,
  PrinterIcon,
  RocketIcon,
  ScaleIcon,
  ScanLineIcon,
  ScrollTextIcon,
  Share2Icon,
  ShuffleIcon,
  SparklesIcon,
  SwordsIcon,
  TrophyIcon,
  UploadIcon,
  UsersIcon,
  WalletIcon,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { createElement } from "react";

const MILESTONE_ICONS: Record<string, LucideIcon> = {
  "arrow-right-left": ArrowRightLeftIcon,
  ban: BanIcon,
  bot: BotIcon,
  "clipboard-list": ClipboardListIcon,
  "file-warning": FileWarningIcon,
  "folder-sync": FolderSyncIcon,
  "gamepad-2": Gamepad2Icon,
  "git-branch": GitBranchIcon,
  "hand-heart": HandHeartIcon,
  heart: HeartIcon,
  languages: LanguagesIcon,
  layers: LayersIcon,
  library: LibraryIcon,
  "list-checks": ListChecksIcon,
  medal: MedalIcon,
  "monitor-play": MonitorPlayIcon,
  "package-open": PackageOpenIcon,
  palette: PaletteIcon,
  "pie-chart": PieChartIcon,
  printer: PrinterIcon,
  rocket: RocketIcon,
  scale: ScaleIcon,
  "scan-line": ScanLineIcon,
  "scroll-text": ScrollTextIcon,
  "share-2": Share2Icon,
  shuffle: ShuffleIcon,
  swords: SwordsIcon,
  trophy: TrophyIcon,
  upload: UploadIcon,
  users: UsersIcon,
  wallet: WalletIcon,
};

export function MilestoneIcon({ token, className }: { token?: string; className?: string }) {
  const icon = (token === undefined ? undefined : MILESTONE_ICONS[token]) ?? SparklesIcon;
  return createElement(icon, { className });
}
